export default __webpack_public_path__ + "static/article-what-to-look-for-when-choosing-your-financial-institution-83f806fe36ecc6cd6621aad60094092d.jpg";